import { FileText, Plus } from 'lucide-react';
import { Button } from '@ideoz/ui';
import { EmptyState } from '@ideoz/ui/components/molecules/EmptyState';

interface FilesEmptyStateProps {
  body: string;
  onUpload: () => void;
}

export function FilesEmptyState({ body, onUpload }: FilesEmptyStateProps): JSX.Element {
  return (
    <EmptyState
      title="Nothing to see here yet"
      description="Upload specs or references so Ideoz can ground its work in your real context."
      action={
        <Button onClick={onUpload} variant="outline" size="sm">
          Upload your first file
        </Button>
      }
    />
  );
}
